module.exports = __webpack_public_path__ + "static/img/A (19).9513f59e.png";